module.exports = __webpack_public_path__ + "static/qr2.c8859c8a.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/qr2.png
// module id = 1050
// module chunks = 2